import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
// Not ~/entities/blog/api: beforeLoad stays in the main chunk (only the component is split off), and api.ts would
// bring every article's meta with it.
import { getPostLanguages } from '~/entities/blog/languages';
import { PostDetailPage } from '~/pages/blog-detail';

export const Route = createFileRoute('/blog_/$slug')({
  // An article missing in the address's language goes to that language's listing, which names it and links
  // the languages it exists in; the same target as the server's 302 (server/pages.mjs). A slug that exists
  // in no language is a 404. Without a language in the address (dev server) the page keeps its fallback.
  beforeLoad: ({ params, context }) => {
    const languages = getPostLanguages(params.slug);
    if (languages.length === 0) {
      throw notFound();
    }
    const language = context.urlLanguage.current();
    if (language && !languages.includes(language)) {
      throw redirect({ to: '/blog', search: { missing: params.slug }, replace: true });
    }
  },
  component: PostDetailRoute,
});

function PostDetailRoute() {
  const { slug } = Route.useParams();

  return <PostDetailPage slug={slug} />;
}
